export enum ScheduledType {
    none = "none",
    scheduled = "Shared Form",
    onDemand = "Standard Form Submissions",
    onDemandForm = "Standard Form Templates"
}
